import { Grid, IconButton, Typography } from '@mui/material';

import React from 'react';

import { ReactComponent as DeleteAlertIcon } from 'common/assets/images/delete-file.svg';
import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import {
	DELETE_FILE_LABEL,
	DELETE_CONFIRMATION_UNDONE_LABEL,
	DELETE_CONFIRMATION_LABEL,
	BUTTON_LABELS,
} from 'common/constants/index';

import ButtonComp from '../Button/ButtonComp';
import ModalEle from '../Modal/ModalEle';

import styles from './DeleteFileModal.module.scss';

interface IDeleteFileModalProps {
	deleteActionHandler: (data: any) => void;
	isOpen: boolean;
	handleModalClose: () => void;
	data: any;
	isLoading?: boolean;
}
const DeleteFileModal = ({
	deleteActionHandler,
	isOpen,
	handleModalClose,
	data,
	isLoading = false,
}: IDeleteFileModalProps) => {
	const { drawerCloseIconColor } = styles;

	const modalBoxProps = { width: '35%', height: '35%', zIndex: '1255' };
	const { CANCEL, DELETE } = BUTTON_LABELS;
	const onDelete = () => deleteActionHandler(data);
	return (
		<ModalEle
			open={isOpen}
			handleClose={handleModalClose}
			sxBoxProps={modalBoxProps}
		>
			<Grid
				container
				xs={12}
				lg={12}
				sm={12}
				md={12}
				direction="row"
				data-testid="delete-file-modal"
				className={styles['delete-file-modal-label-container']}
			>
				<Grid
					direction="row"
					container
					item
					xs={12}
					lg={12}
					sm={12}
					md={12}
					className={styles['delete-file-modal-delete-label']}
				>
					{DELETE_FILE_LABEL}
					<IconButton
						size="medium"
						onClick={handleModalClose}
						data-testid="close-modal"
					>
						<DrawerClose fill={drawerCloseIconColor} />
					</IconButton>
				</Grid>
				<Grid container item xs={12} lg={12} sm={12} md={12} mt={2} ml={2}>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						direction="row"
						className={styles['delete-file-modal-error-label']}
					>
						<Grid item className={styles['delete-file-icon-container']}>
							<DeleteAlertIcon />
							<Typography className={styles['delete-file-icon-text']}>
								{DELETE_CONFIRMATION_LABEL}
							</Typography>
						</Grid>

						<Grid item className={styles['delete-file-modal-undo-text']}>
							&quot;{data?.name}&quot;{DELETE_CONFIRMATION_UNDONE_LABEL}
						</Grid>
					</Grid>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						mt={1}
						className={styles['delete-file-modal-btngrp']}
					>
						<ButtonComp
							btnType="secondary"
							clickHandler={handleModalClose}
							data-testid="deletemodal-cancel"
						>
							{CANCEL}
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							clickHandler={onDelete}
							data-testid="deletemodal-save"
							loading={isLoading}
						>
							{DELETE}
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</ModalEle>
	);
};
export default DeleteFileModal;
